import React, { useState, useEffect } from 'react';
import useApi from '../../hooks/useApi';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import ErrorMessage from '../../components/common/ErrorMessage';

const AttributeForm = ({ attribute, onClose, onSaveSuccess }) => {
  const api = useApi();
  const [name, setName] = useState(attribute?.name || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (attribute) setName(attribute.name);
  }, [attribute]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      if (attribute) {
        await api.put(`attributes/${attribute._id}`, { name });
      } else {
        await api.post('attributes', { name });
      }
      onSaveSuccess();
      onClose();
    } catch (err) {
      setError(err.message || 'Operation failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {loading && <LoadingSpinner />}
      {error && <ErrorMessage message={error} />}
      <div>
        <label className="block text-sm font-medium text-gray-700">Attribute Name</label>
        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          required
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
        />
      </div>
      <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
        >
          {loading ? 'Saving...' : attribute ? 'Save Changes' : 'Add Attribute'}
        </button>
      </div>
    </form>
  );
};

export default AttributeForm;